import _ from "lodash";
import dotProp from "dot-prop-immutable"

import { verifyDocNameUniqueness } from "@meddbriefer/scenario-data"

export async function validateScenarioNameUniqueness(db, candidateName, scenario) {
    if (candidateName === scenario.name) {
        return true
    }
    const isUnique = await verifyDocNameUniqueness(db, "scenarios", candidateName, scenario.schemaVersion)
    return isUnique
}

// _.isEqualWith helper func which ignores strings which differ only by trailing space
export function ignoreTrailingSpaceInStrings(objValue, othValue) {
    if (_.isString(objValue) && _.isString(othValue)) {
        return _.eq(objValue.trim(), othValue.trim())
    }
}

export const applyFieldDefaultValue = (cleanedValues, fldPath, defaultValue) => {
    // sets to defaultValue if not set
    const val = dotProp.get(cleanedValues, fldPath)
    if (!val || "" === val) {
        console.debug(`set ${fldPath} to defaultValue: "${defaultValue}`)
        return dotProp.set(cleanedValues, fldPath, defaultValue)
    }
     // no changes
    return cleanedValues
}

export const trimFieldValue = (cleanedValues, fldPath) => {
    // trims value if it 's a string
    const val = dotProp.get(cleanedValues, fldPath)
    if (_.isString(val)) {
        const trimmedVal = val.trim()
        if (trimmedVal !== val) {
            console.debug(`trimmed string value of ${fldPath}`)
            return dotProp.set(cleanedValues, fldPath, trimmedVal)
        }
    }
     // no changes
     return cleanedValues
 }


export function processForm(scenario, form) {
    let input, id, path,
        newScenario = deepCopy(scenario);

    for (const fld of form) {
        if ("submit" === fld.type) continue
        id = fld.id;
        path = id.split('-');
        input = fld.type === "checkbox"
            ? fld.checked
            : fld.value;
        // console.log(id, input, fld.defaultValue)

        // Default inputs
        if (!input) {
            switch (path[0]) {
                case 'assessmentFindings':
                    input = "Unremarkable";
                    break;
                case 'OPQRST':
                    input = "Unable to assess";
                    break;
                case 'correctMedicationDosages':
                    console.log(fld.dataset.isadministrationtype)
                    if (!fld.dataset.isadministrationtype)
                        input = "";
                    break;

                default: break;
            }
        }

        if (input) { // Don't process empty fields
            // Reconstruct assessmentFindings path after split
            if (path[0] === 'assessmentFindings')
                path = [path[0], id.split('assessmentFindings-')[1]];

            // Read numbers as integers (should we do floats and then determine if they are ints?)
            input = isNaN(input) ? input : parseInt(input) || input;

            // Handle different object depths
            switch (path.length) {
                case 1: newScenario[path[0]] = input; break;
                case 2: newScenario[path[0]][path[1]] = input; break;
                case 3: newScenario[path[0]][path[1]][path[2]] = input; break;
                case 4: newScenario[path[0]][path[1]][path[2]][path[3]] = input; break;

                default: console.error(`Path length '${path.length}' error:`, fld); break;
            }
        }
    }

    console.log(newScenario);

    return newScenario;
}

export function processFormOrig(scenario, data, isEdit, asTemplate, scenarioId) {
    let input, id, path,
        newScenario = deepCopy(scenario);

    for (let item of data) {
            id = item.id;
            path = id.split('-');


        // Default inputs
        if (!input) {
            switch (path[0]) {
                case 'assessmentFindings':
                    input = "Unremarkable";
                    break;
                case 'OPQRST':
                    input = "Unable to assess";
                    break;
                case 'correctMedicationDosages':
                    if (!item.dataset.isadministrationtype)
                        input = "default";
                    break;

                default: break;
            }
        }

        if (input) { // Don't process empty fields
            // Reconstruct assessmentFindings path after split
            if (path[0] === 'assessmentFindings')
                path = [path[0], id.split('assessmentFindings-')[1]];

            // Read numbers as numbers
            input = isNaN(input) ? input : parseInt(input);

            // Handle different object depths
            switch (path.length) {
                case 1: newScenario[path[0]] = input; break;
                case 2: newScenario[path[0]][path[1]] = input; break;
                case 3: newScenario[path[0]][path[1]][path[2]] = input; break;

                default: console.error(`Path length '${path.length}' error:`, item); break;
            }
        }
    }

    if (isEdit && !asTemplate) {
        newScenario.id = scenarioId
    }

    return newScenario;
}

export function deepCopy(obj) {
    return JSON.parse(JSON.stringify(obj));
}
